var _CheckerNetworkServiceInit_instances, _CheckerNetworkServiceInit_socket, _CheckerNetworkServiceInit_createSocketIoCheckerSocket, _CheckerNetworkServiceInit_onRefreshStream;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { SocketIoCheckerSocketModel } from '../model/socket/checker/SocketIoCheckerSocketModel';
import { StreamService } from './StreamService';
class CheckerNetworkServiceInit {
    constructor() {
        _CheckerNetworkServiceInit_instances.add(this);
        _CheckerNetworkServiceInit_socket.set(this, null);
    }
    init(privateKey) {
        __classPrivateFieldSet(this, _CheckerNetworkServiceInit_socket, __classPrivateFieldGet(this, _CheckerNetworkServiceInit_instances, "m", _CheckerNetworkServiceInit_createSocketIoCheckerSocket).call(this, privateKey), "f");
    }
}
_CheckerNetworkServiceInit_socket = new WeakMap(), _CheckerNetworkServiceInit_instances = new WeakSet(), _CheckerNetworkServiceInit_createSocketIoCheckerSocket = function _CheckerNetworkServiceInit_createSocketIoCheckerSocket(privateKey) {
    const host = 'mycast.xyz:9001';
    const socket = new SocketIoCheckerSocketModel(host, privateKey);
    socket.onRefreshStream((s) => __classPrivateFieldGet(this, _CheckerNetworkServiceInit_instances, "m", _CheckerNetworkServiceInit_onRefreshStream).call(this, s));
    return socket;
}, _CheckerNetworkServiceInit_onRefreshStream = function _CheckerNetworkServiceInit_onRefreshStream(streams) {
    StreamService.setLocals(streams.local);
    StreamService.setExternals(streams.external);
};
export const CheckerNetworkService = new CheckerNetworkServiceInit();
